<div class="inventory box-content">
  <ng-container *ngFor="let summary of summaryList">
    <div [ngClass]="[summary?.showHoverCls ? 'hover-item-cls' : '', 'flex-item']"
      (click)="summary?.gotoOtherPage ? summary.gotoOtherPage(summary.status) : fallback()">
      <div class="label-text">
        {{ summary.text }}<span class="num" *ngIf="summary.showTotalTag && summary.count > 0">{{ summary.count }}</span>
      </div>
      <div [ngClass]="{ 'negative-number': summary?.showNegativeCls }">{{ summary.totalCost }}</div>
      <img *ngIf="summary.showArrowIcon" src="{{'assets/img/right.png' | xviSourcePath }}" />
    </div>
  </ng-container>
</div>
